import { H3 } from "@/shared/components/typography";
import t from "@/lang/lang";
import {
  RelationshipsTable,
  RelationshipsTableFilters,
} from "@/services/backend/relationships/components/relationships-table";
import { ReactNode, useCallback, useState } from "react";
import { ListRequest } from "@/services/backend/relationships/api/service";
import { CreateRelationshipDialog } from "@/services/backend/relationships/components/create-relationship-dialog";
import {
  CustomerPageMain,
  CustomerPageMainContent,
  CustomerPageMainHeader,
} from "@/routes/customers/[customerId]/_components/customer-page";
import { CustomerPageBreadcrumbs } from "@/routes/customers/[customerId]/_components/customer-page-breadcrumbs";
import { NavLink, useParams } from "react-router";

export function RelationshipsRoute() {
  const { customerId } = useParams();

  const [request, setRequest] = useState<ListRequest>({
    customer: { active: true, values: [customerId!] },
    limit: 10,
    offset: 0,
  });

  const renderRowLink = useCallback(
    (relationship: { id: string; customerId: string }, children: ReactNode) => (
      <NavLink
        to={`/customers/${relationship.customerId}/relationships/${relationship.id}`}
      >
        {children}
      </NavLink>
    ),
    [],
  );

  return (
    <CustomerPageMain>
      <CustomerPageMainHeader>
        <CustomerPageBreadcrumbs
          breadcrumbs={[
            {
              to: `/customers/${customerId}/relationships`,
              label: t("Beziehungen"),
            },
          ]}
        />
      </CustomerPageMainHeader>
      <CustomerPageMainContent>
        <H3>{t("Beziehungen")}</H3>
        <div className="text-muted-foreground text-sm">
          {t(
            "Beziehungen stellen die Verbindung zwischen einem Unternehmen und einem Objekt eines Kunden da. Eine Beziehung kann implizit bestehen oder durch einen Vertrag formalisiert sein. Eine Beziehung kann mehrere Dienstleistungen umfassen. Sie ist ebenso unabhängig von Vorgängen.",
          )}
        </div>
        <div className="mt-4 grid gap-2">
          <div className="flex items-center justify-between">
            <RelationshipsTableFilters
              request={request}
              onRequestChange={setRequest}
              hideCustomerFilter
            />
            <CreateRelationshipDialog customerId={customerId} />
          </div>
          <RelationshipsTable
            request={request}
            onRequestChange={setRequest}
            renderRowLink={renderRowLink}
          />
        </div>
      </CustomerPageMainContent>
    </CustomerPageMain>
  );
}
